module.exports = __webpack_public_path__ + "img/object.c365c2da.svg";